import type { ReactNode } from "react";

type AdminPillBadgeProps = {
  children: ReactNode;
  tone?: "neutral" | "success" | "warning" | "danger";
};

const toneClassName: Record<NonNullable<AdminPillBadgeProps["tone"]>, string> = {
  neutral: "border-myteengig-border bg-myteengig-background text-myteengig-text-muted",
  success: "border-emerald-200 bg-emerald-50 text-emerald-700",
  warning: "border-amber-200 bg-amber-50 text-amber-700",
  danger: "border-rose-200 bg-rose-50 text-rose-700",
};

const AdminPillBadge = ({ children, tone = "neutral" }: AdminPillBadgeProps) => {
  return (
    <span className={`inline-flex rounded-full border px-2.5 py-1 text-xs font-semibold ${toneClassName[tone]}`}>
      {children}
    </span>
  );
};

export default AdminPillBadge;
